/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ orderId: NonNullable<unknown> }} Order_Not_Found_ErrorInputs */

const en_order_not_found_error = /** @type {(inputs: Order_Not_Found_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Could not find order with id "${i?.orderId}".`)
};

const id_order_not_found_error = /** @type {(inputs: Order_Not_Found_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tidak dapat menemukan pesanan dengan id "${i?.orderId}".`)
};

const ms_order_not_found_error = /** @type {(inputs: Order_Not_Found_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tidak jumpa tempahan dengan id "${i?.orderId}".`)
};

const ca_order_not_found_error = /** @type {(inputs: Order_Not_Found_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`No s'ha pogut trobar la comanda amb la ID "${i?.orderId}".`)
};

const cs_order_not_found_error = /** @type {(inputs: Order_Not_Found_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nepodařilo se najít objednávku s id „${i?.orderId}“.`)
};

const da_order_not_found_error = /** @type {(inputs: Order_Not_Found_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Kunne ikke finde en ordre med ID "${i?.orderId}".`)
};

const de_order_not_found_error = /** @type {(inputs: Order_Not_Found_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bestellung mit der ID „${i?.orderId}“ konnte nicht gefunden werden.`)
};

const et_order_not_found_error = /** @type {(inputs: Order_Not_Found_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tellimust ID-ga „${i?.orderId}“ ei leitud.`)
};

const es_order_not_found_error = /** @type {(inputs: Order_Not_Found_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`No pudimos encontrar un pedido con el ID “${i?.orderId}”.`)
};

const fr_order_not_found_error = /** @type {(inputs: Order_Not_Found_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Numéro de commande ${i?.orderId} introuvable.`)
};

const hr_order_not_found_error = /** @type {(inputs: Order_Not_Found_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nismo mogli naći narudžbu s brojem „${i?.orderId}”.`)
};

const it_order_not_found_error = /** @type {(inputs: Order_Not_Found_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Non abbiamo trovato ordini con ID "${i?.orderId}".`)
};

const lv_order_not_found_error = /** @type {(inputs: Order_Not_Found_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Neizdevās atrast pasūtījumu ar ID “${i?.orderId}”.`)
};

const lt_order_not_found_error = /** @type {(inputs: Order_Not_Found_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nepavyko rasti užsakymo su ID „${i?.orderId}“.`)
};

const hu_order_not_found_error = /** @type {(inputs: Order_Not_Found_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nem sikerült megtalálni az „${i?.orderId}” azonosítójú rendelést.`)
};

const nl_order_not_found_error = /** @type {(inputs: Order_Not_Found_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Geen bestelling met ID '${i?.orderId}' gevonden.`)
};

const nb_order_not_found_error = /** @type {(inputs: Order_Not_Found_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Fant ingen bestilling med nummer «${i?.orderId}».`)
};

const pl_order_not_found_error = /** @type {(inputs: Order_Not_Found_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nie udało się znaleźć zamówienia o identyfikatorze „${i?.orderId}”.`)
};

const pt_order_not_found_error = /** @type {(inputs: Order_Not_Found_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Não foi possível encontrar o pedido com a ID "${i?.orderId}".`)
};

const ro_order_not_found_error = /** @type {(inputs: Order_Not_Found_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nu am reușit să identificăm comanda cu numărul de identificare "${i?.orderId}".`)
};

const sk_order_not_found_error = /** @type {(inputs: Order_Not_Found_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nepodarilo sa nájsť objednávku s id "${i?.orderId}".`)
};

const sl_order_not_found_error = /** @type {(inputs: Order_Not_Found_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ni bilo mogoče najti naročila z ID-jem »${i?.orderId}«.`)
};

const fi_order_not_found_error = /** @type {(inputs: Order_Not_Found_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tilausta tunnuksella "${i?.orderId} " ei löytynyt.`)
};

const sv_order_not_found_error = /** @type {(inputs: Order_Not_Found_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Kunde inte hitta beställning med id "${i?.orderId}".`)
};

const vi_order_not_found_error = /** @type {(inputs: Order_Not_Found_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Không thể tìm được đơn hàng có ID "${i?.orderId}".`)
};

const tr_order_not_found_error = /** @type {(inputs: Order_Not_Found_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`"${i?.orderId}" numaralı sipariş bulunamıyor.`)
};

const el_order_not_found_error = /** @type {(inputs: Order_Not_Found_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Αδυναμία εύρεσης παραγγελίας με αναγνωριστικό «${i?.orderId}».`)
};

const bg_order_not_found_error = /** @type {(inputs: Order_Not_Found_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Не беше намерена поръчка с ID „${i?.orderId}“.`)
};

const ru_order_not_found_error = /** @type {(inputs: Order_Not_Found_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Не удалось найти заказ с идентификатором "${i?.orderId}".`)
};

const sr_order_not_found_error = /** @type {(inputs: Order_Not_Found_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Није пронађена наруџбина са бројем „${i?.orderId}“.`)
};

const uk_order_not_found_error = /** @type {(inputs: Order_Not_Found_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Не вдалося знайти замовлення з ідентифікатором "${i?.orderId}".`)
};

const ka_order_not_found_error = /** @type {(inputs: Order_Not_Found_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`შეკვეთა ვერ მოიძებნა Id-ით „${i?.orderId}“.`)
};

const hi_order_not_found_error = /** @type {(inputs: Order_Not_Found_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`"${i?.orderId}" आईडी वाला ऑर्डर नहीं मिल सका।`)
};

const th_order_not_found_error = /** @type {(inputs: Order_Not_Found_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ไม่พบคำสั่งซื้อที่มีรหัส "${i?.orderId}"`)
};

const ko_order_not_found_error = /** @type {(inputs: Order_Not_Found_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`'${i?.orderId}' ID와 연관된 주문을 찾을 수 없습니다.`)
};

const zh_order_not_found_error = /** @type {(inputs: Order_Not_Found_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`无法找到 ID 为“${i?.orderId}”的订单。`)
};

const zh_tw_order_not_found_error = /** @type {(inputs: Order_Not_Found_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`無法找到 id 為「${i?.orderId}」的訂單。`)
};

const ja_order_not_found_error = /** @type {(inputs: Order_Not_Found_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ID "${i?.orderId}" の注文が見つかりませんでした。`)
};

/**
* | output |
* | --- |
* | "Could not find order with id \"{orderId}\"." |
*
* @param {Order_Not_Found_ErrorInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const order_not_found_error = /** @type {((inputs: Order_Not_Found_ErrorInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Not_Found_ErrorInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_order_not_found_error(inputs)
	if (locale === "ms") return ms_order_not_found_error(inputs)
	if (locale === "ca") return ca_order_not_found_error(inputs)
	if (locale === "cs") return cs_order_not_found_error(inputs)
	if (locale === "da") return da_order_not_found_error(inputs)
	if (locale === "de") return de_order_not_found_error(inputs)
	if (locale === "et") return et_order_not_found_error(inputs)
	if (locale === "es") return es_order_not_found_error(inputs)
	if (locale === "fr") return fr_order_not_found_error(inputs)
	if (locale === "hr") return hr_order_not_found_error(inputs)
	if (locale === "it") return it_order_not_found_error(inputs)
	if (locale === "lv") return lv_order_not_found_error(inputs)
	if (locale === "lt") return lt_order_not_found_error(inputs)
	if (locale === "hu") return hu_order_not_found_error(inputs)
	if (locale === "nl") return nl_order_not_found_error(inputs)
	if (locale === "nb") return nb_order_not_found_error(inputs)
	if (locale === "pl") return pl_order_not_found_error(inputs)
	if (locale === "pt") return pt_order_not_found_error(inputs)
	if (locale === "ro") return ro_order_not_found_error(inputs)
	if (locale === "sk") return sk_order_not_found_error(inputs)
	if (locale === "sl") return sl_order_not_found_error(inputs)
	if (locale === "fi") return fi_order_not_found_error(inputs)
	if (locale === "sv") return sv_order_not_found_error(inputs)
	if (locale === "vi") return vi_order_not_found_error(inputs)
	if (locale === "tr") return tr_order_not_found_error(inputs)
	if (locale === "el") return el_order_not_found_error(inputs)
	if (locale === "bg") return bg_order_not_found_error(inputs)
	if (locale === "ru") return ru_order_not_found_error(inputs)
	if (locale === "sr") return sr_order_not_found_error(inputs)
	if (locale === "uk") return uk_order_not_found_error(inputs)
	if (locale === "ka") return ka_order_not_found_error(inputs)
	if (locale === "hi") return hi_order_not_found_error(inputs)
	if (locale === "th") return th_order_not_found_error(inputs)
	if (locale === "ko") return ko_order_not_found_error(inputs)
	if (locale === "zh") return zh_order_not_found_error(inputs)
	if (locale === "zh-tw") return zh_tw_order_not_found_error(inputs)
	if (locale === "ja") return ja_order_not_found_error(inputs)
	return en_order_not_found_error(inputs)
});